import styled, { css } from 'styled-components';
import SVGComponent from '@components/1-atoms/SVG';
import { flexCenterVertical, flexColumn } from '@stylesheets/helpers';

export const Header = styled.div`
  ${flexCenterVertical}

  ${({ theme: { spacing } }) => css`
    padding: ${spacing?.level6} ${spacing?.level4};
    gap: ${spacing?.level3};
  `}
`;

export const Logo = styled(SVGComponent).attrs(({ theme: { isLightTheme } }) => ({
  name: isLightTheme ? 'logo-white' : 'logo',
}))`
  width: 48px;
  height: 48px;

  ${({ theme: { colors } }) => css`
    color: ${colors?.onSurface};

    g[mask] path {
      fill: currentColor;
    }
  `}
`;

export const BrandName = styled.span`
  ${({ theme: { font, colors } }) => css`
    ${font?.titleMedium}
    color: ${colors?.onSurface};
  `}
`;

export const LoginForm = styled.form`
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${({ theme: { spacing } }) => css`
    padding: 0 ${spacing?.level5};
  `}

  .login-step {
    flex: 0 1 auto;
  }
`;

export const LoginStepContent = styled.div`
  ${flexColumn}

  ${({ theme: { spacing } }) => css`
    gap: ${spacing?.level4};
    padding-bottom: ${spacing?.level5};
  `}
`;

export const MfaForm = styled.form`
  ${flexColumn}

  ${({ theme: { spacing } }) => css`
    gap: ${spacing?.level4};
  `}
`;

export const FooterLinks = styled.div`
  margin-top: auto;

  ${({ theme: { spacing } }) => css`
    padding: ${spacing?.level6} ${spacing?.level5};
  `}
`;
